var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shared-edit-invoice',{attrs:{"invoice-id":Number(_vm.$route.params.id),"is-accounting-interface":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }